import { render, staticRenderFns } from "./layout-default.vue?vue&type=template&id=4b650f8a&scoped=true&"
import script from "./layout-default.vue?vue&type=script&lang=js&"
export * from "./layout-default.vue?vue&type=script&lang=js&"
import style0 from "./layout-default.vue?vue&type=style&index=0&lang=css&"
import style1 from "./layout-default.vue?vue&type=style&index=1&id=4b650f8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b650f8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b650f8a')) {
      api.createRecord('4b650f8a', component.options)
    } else {
      api.reload('4b650f8a', component.options)
    }
    module.hot.accept("./layout-default.vue?vue&type=template&id=4b650f8a&scoped=true&", function () {
      api.rerender('4b650f8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/layouts/layout-default.vue"
export default component.exports